import { render, staticRenderFns } from "./NsbReject.vue?vue&type=template&id=08167635&scoped=true&"
import script from "./NsbReject.vue?vue&type=script&lang=js&"
export * from "./NsbReject.vue?vue&type=script&lang=js&"
import style0 from "./NsbReject.vue?vue&type=style&index=0&id=08167635&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08167635",
  null
  
)

export default component.exports